<template>
    <div class="portlet-body form">
        <form class="form-horizontal" role="form">
            <div class="form-body">
                <h3 class="form-section" style="margin-top: 0">{{ 'assign_team.assign_team' | trans }}</h3>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="col-md-4 control-label">{{ 'days.form.delivery_date' | trans }}:</label>
                            <div class="col-md-8">
                                <date-picker
                                        v-model="formDate"
                                        :time="false"
                                        :is-nullable="false"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 pl-0">
                        <button
                                type="button"
                                class="btn btn-primary"
                                :disabled="disabled"
                                @click="search">
                            {{ 'common.show' | trans }}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="col-md-4 control-label">{{ 'brand.brand' | trans }}:</label>
                            <div class="col-md-8">
                                <multi-select
                                        v-model="formBrands"
                                        :options="brands"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <checkbox
                                    v-model="formAllBrands"
                                    class="assign-team-search-checkbox"
                                    label-side="right"
                                    label="Wszystkie"
                                    :disabled="!formBrands.length"
                                    :label-size="11"
                            />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="col-md-4 control-label">{{ 'team.teams' | trans }}:</label>
                            <div class="col-md-8">
                                <multi-select
                                    v-model="formTeams"
                                    :options="teams"
                                />
                            </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <checkbox
                                v-model="formAllTeams"
                                class="assign-team-search-checkbox"
                                label-side="right"
                                label="Wszystkie"
                                :disabled="!formTeams.length"
                                :label-size="11"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Checkbox from '@component/dccore-form/checkbox.vue'
import DatePicker from '@component/datePicker.vue'
import MultiSelect from '@component/multiselect.vue'
import axios from 'axios'

export default {
  name: 'AssignTeamSearch',
  components: {
    DatePicker,
    MultiSelect,
    Checkbox
  },
  props: {
    date: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      formDate: this.date,
      formBrands: [],
      formAllBrands: true,
      brands: [],
      formTeams: [],
      formAllTeams: true,
      teams: [],
      optionNoTeam: [
        {
          id: 'empty',
          name: Translator.trans('team.no_team')
        }
      ],
    }
  },
  watch: {
    formDate(value) {
      this.$emit('update:date', value)
    },
    formBrands(value) {
      this.formAllBrands = !value.length
    },
    formTeams(value) {
      this.formAllTeams = !value.length
    }
  },
  mounted() {
    this.getBrands()
    this.getTeams()
  },
  methods: {
    search() {
      this.$emit('request')
      axios.post(
        Routing.generate('api_post_assign_team_by_date_group_meal'),
        {
          data: {
            date: this.formDate,
            brands: this.formAllBrands ? [] : this.formBrands,
            merge: false,
            teams: this.formAllTeams ? [] : this.formTeams.filter(item => item !== this.optionNoTeam[0].id),
            emptyTeams: this.formTeams.includes(this.optionNoTeam[0].id)
          }
        }
      ).then(response => {
        this.$emit('response', Object.values(response.data))
      }, response => {
        this.handleAjaxError(response)
        this.$emit('response', [])
      })
    },
    getBrands() {
      this.$emit('request')
      const url = Routing.generate('api_get_brands', { context: 'dropdown' })

      axios.get(url).then(response => {
        this.brands = response.data
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.$emit('response')
      })
    },
    getTeams() {
      this.$emit('request')
      const url = Routing.generate('api_get_active_production_teams', { context: 'dropdown' })

      axios.get(url).then(response => {
        this.teams = [...this.optionNoTeam, ...response.data]
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.$emit('response')
      })
    },
  }
}
</script>

<style>
.assign-team-search-checkbox .col-md-1 {
    width: 20px;
}
</style>
